import { render, staticRenderFns } from "./SafeList.vue?vue&type=template&id=1338ce71"
import script from "./SafeList.vue?vue&type=script&lang=js"
export * from "./SafeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports